export const SMS_SEGMENT_LENGTH = 160;
export const SMS_MAX_SEGMENTS = 3;

export function splitIntoSegments(text: string): string[] {
  const segments: string[] = [];
  let remaining = text;
  while (remaining.length > SMS_SEGMENT_LENGTH) {
    const chunk = remaining.slice(0, SMS_SEGMENT_LENGTH);
    const lastSpace = chunk.lastIndexOf(' ');
    const splitAt = lastSpace > 0 ? lastSpace : SMS_SEGMENT_LENGTH;
    segments.push(remaining.slice(0, splitAt).trimEnd());
    remaining = remaining.slice(splitAt).trimStart();
  }
  if (remaining.length > 0) segments.push(remaining);
  return segments;
}
